import React from 'react'
import { Modal, Table, Row, Col } from 'antd'
import {
  CheckCircleFilled,
  WarningFilled,
  ExclamationCircleFilled,
} from '@ant-design/icons'

const HollowCircle = ({ size = 20, color = '#ffffff8e' }) => (
  <span
    style={{
      display: 'inline-block',
      width: size,
      height: size,
      borderRadius: '50%',
      border: `2px solid ${color}`,
    }}
  />
)

const StatusLabel = ({ label, status }) => {
  const renderIcon = () => {
    switch (status) {
      case 'SUCCESS':
        return <CheckCircleFilled style={{ color: '#52c41a', fontSize: 22 }} />

      case 'WARNING':
        return <WarningFilled style={{ color: '#faad14', fontSize: 22 }} />

      case 'FAILED':
        return (
          <ExclamationCircleFilled style={{ color: '#f5222d', fontSize: 22 }} />
        )

      case 'WAITING':
      default:
        return <HollowCircle size={22} color="#8c8c8c" />
    }
  }

  return (
    <div style={{ textAlign: 'center', marginBottom: 12 }}>
      <div
        style={{
          fontWeight: 700,
          marginBottom: 6,
          fontSize: 20,
        }}
      >
        {label}
      </div>
      {renderIcon()}
    </div>
  )
}

export const PauseUnpauseModal = ({
  open,
  onCancel,
  pauseStatus,
  unpauseStatus,
  pauseTxHashes,
  unpauseTxHashes,
  formatAddress,
  configs,
  t,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      closable
      maskClosable
      width={900}
      title={
        <h3 className="flex justify-center text-xl font-normal text-[#fff]">
          Pause / Unpause Contracts Details
        </h3>
      }
    >
      <Row gutter={24}>
        {/* ========== PAUSE ========== */}
        <Col span={12}>
          <StatusLabel label="Pause" status={pauseStatus} />

          <Table
            size="small"
            pagination={false}
            rowKey="contract"
            dataSource={Object.entries(pauseTxHashes || {}).map(
              ([contract, tx]) => ({ contract, tx }),
            )}
            columns={[
              {
                title: 'Contract',
                dataIndex: 'contract',
                onHeaderCell: () => ({
                  style: { paddingLeft: 60 },
                }),
                onCell: () => ({
                  style: { paddingLeft: 60 },
                }),
              },
              {
                title: 'TxHash',
                dataIndex: 'tx',
                render: (tx) =>
                  !tx || tx === 'failed' ? (
                    <span style={{ color: '#f5222d' }}>Failed</span>
                  ) : (
                    <a
                      href={`${configs.NETWORK.scan}tx/${tx}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: '#40A9FF' }}
                    >
                      {formatAddress(tx)}
                    </a>
                  ),
              },
            ]}
          />
        </Col>

        {/* ========== UNPAUSE ========== */}
        <Col span={12}>
          <StatusLabel label="Unpause" status={unpauseStatus} />

          <Table
            size="small"
            pagination={false}
            rowKey="contract"
            dataSource={Object.entries(unpauseTxHashes || {}).map(
              ([contract, tx]) => ({ contract, tx }),
            )}
            columns={[
              {
                title: 'Contract',
                dataIndex: 'contract',
                onHeaderCell: () => ({
                  style: { paddingLeft: 60 },
                }),
                onCell: () => ({
                  style: { paddingLeft: 60 },
                }),
              },
              {
                title: 'TxHash',
                dataIndex: 'tx',
                render: (tx) =>
                  !tx || tx === 'failed' ? (
                    <span style={{ color: '#f5222d' }}>Failed</span>
                  ) : (
                    <a
                      href={`${configs.NETWORK.scan}tx/${tx}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: '#40A9FF' }}
                    >
                      {formatAddress(tx)}
                    </a>
                  ),
              },
            ]}
          />
        </Col>
      </Row>
    </Modal>
  )
}
